import React, { useState, useEffect, useRef } from 'react';
import '../styles/ChatWidget.css';

const ChatWidget = () => {
  const [isVisible, setIsVisible] = useState(false);
  const widgetRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const interval = setInterval(() => {
      const widget = document.querySelector('elevenlabs-convai');
      if (widget && widget.shadowRoot) {
        const selectors = [
          'p.whitespace-nowrap',
          'p[class*="whitespace-nowrap"]',
          'p[class*="text-[10px]"]',
          'p:has(span[class*="opacity-30"])',
          'p:has(a[href*="elevenlabs.io"])',
          'p:has(a[href*="elevenlabs"])',
          'p:has(a[href*="ElevenAgents"])',
          'p:has(a[href*="elevenagents"])'
        ];
        let found = false;
        for (const selector of selectors) {
          try {
            const el = widget.shadowRoot.querySelector(selector);
            if (el) { el.remove(); found = true; break; }
          } catch (_) { continue; }
        }
        if (found) {
          widget.style.visibility = 'visible';
          clearInterval(interval);
        }
      }
    }, 100);

    setTimeout(() => {
      clearInterval(interval);
      const widget = document.querySelector('elevenlabs-convai');
      if (widget) widget.style.visibility = 'visible';
    }, 15000);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="elevenlabs-widget" ref={widgetRef}>
      <elevenlabs-convai agent-id="agent_01jzgqwvveeak8edqbz77gebam" />
    </div>
  );
};

export default ChatWidget;
